module.exports = __webpack_public_path__ + "static/0-b7d2cc7ffe77e0589b6bd351b85b6d34.png";